import type { PostApiV1RefundsRequest200AllOfThreeDataRefundType } from './postApiV1RefundsRequest200AllOfThreeDataRefundType';
import type { PostApiV1RefundsRequest200AllOfThreeDataStatus } from './postApiV1RefundsRequest200AllOfThreeDataStatus';

export type PostApiV1RefundsRequest200AllOfThreeData = {
  /** AI API 사용 횟수 */
  aiUsageCount?: number;
  /** 환불 가능 여부 */
  canRefund?: boolean;
  /** 환불 신청 일시 */
  createdAt?: string;
  /** 환불 처리 메시지 */
  message?: string;
  /** 주문 ID */
  orderId?: string;
  /** 원래 결제 금액 */
  originalAmount?: number;
  /** 환불 처리 일시 */
  processedAt?: string;
  /** 환불 사유 */
  reason?: string;
  /** 실제 환불 금액 */
  refundAmount?: number;
  /** 환불 신청 ID */
  refundRequestId?: string;
  /** 환불 유형 */
  refundType?: PostApiV1RefundsRequest200AllOfThreeDataRefundType;
  /** 환불 신청 상태 */
  status?: PostApiV1RefundsRequest200AllOfThreeDataStatus;
  /** 구독 사용 일수 */
  subscriptionDaysUsed?: number;
};
